import { render } from "./AppLogo.vue?vue&type=template&id=c01f526c&scoped=true"
const script = {}

import "./AppLogo.vue?vue&type=style&index=0&id=c01f526c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c01f526c"

export default script